"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Oct 11 2018
 */

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Data transfer object describing bind with IDs for unparing objects
 *
 * @author RV
 */


var BindIdsDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(BindIdsDTO, _DomainObject_1$Domai);

  /**
   *
   * @param internalProductId
   * @param competitorProductId
   */
  function BindIdsDTO(internalProductId, competitorProductId) {
    var _this;

    _classCallCheck(this, BindIdsDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BindIdsDTO).call(this));
    _this.internalProductId = internalProductId;
    _this.competitorProductId = competitorProductId;
    return _this;
  }

  return BindIdsDTO;
}(DomainObject_1.DomainObject);

exports.BindIdsDTO = BindIdsDTO; // tslint:disable-next-line:member-ordering

BindIdsDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(BindIdsDTO.name);
  return {
    internalProductId: builder.id('internalProductId'),
    competitorProductId: builder.id('competitorProductId')
  };
}();